import WidgetCard from "@arelia-components/ui-atoms/WidgetCard";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { ChartDatum } from "@arelia-types/index";

ChartJS.register(ArcElement, Tooltip, Legend);

type Props = {
  ages: ChartDatum[];
  loading: boolean;
  error: boolean;
  unconnected: boolean;
};

export default function AgePresenter({ ages, loading, error, unconnected }: Props) {
  const options = {
    rotation: -90,
    circumference: 180,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "bottom" as const,
        display: true,
        labels: {
          boxWidth: 6,
          boxHeight: 6,
          usePointStyle: true,
          padding: 20
        }
      },
      title: {
        display: false,
        text: "",
      },
      datalabels: {
        font: {
          weight: 500,
        },
        formatter: (v: number) => `${v}%`,
      },
      tooltip: {
        callbacks: {
          label(context: any) {
            return ` ${context.parsed}% of total`;
          }
        }
      }
    },
  };

  const data = {
    labels: ages.map(({ label }) => label),
    datasets: [
      {
        data: ages.map(({ value }) => value),
        backgroundColor: [
          "#00EFEF",
          "#0089A9",
          "#51E0C4",
          "#25BB9D",
          "#06B2DA",
        ],
        borderWidth: 0,
        datalabels: {
          color: "#fff",
        },
      },
    ],
  };

  return (
    <WidgetCard
      widgetId="AUDIENCE_AGE"
      title="Audience Age"
      loading={loading}
      error={error}
      unconnected={unconnected}
    >
      {/* @ts-ignore */}
      <Doughnut data={data} options={options} plugins={[ChartDataLabels]} />
    </WidgetCard>
  );
}
